import { render, staticRenderFns } from "./employee-status-table.vue?vue&type=template&id=0a7b80cb"
import script from "./employee-status-table.vue?vue&type=script&lang=js"
export * from "./employee-status-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports